import LegalLayout, { LegalSection } from "@/components/LegalLayout";

const Cookies = () => (
  <LegalLayout title="Política de Cookies">
    <LegalSection title="1. Qué son las cookies">
      <p>
        Las cookies y tecnologías similares (como el almacenamiento local del
        navegador) permiten recordar información sobre tu visita. Este sitio
        utiliza únicamente las tecnologías descritas a continuación: no
        utilizamos cookies de marketing ni publicidad, ni herramientas como
        Google Analytics o Meta Pixel.
      </p>
    </LegalSection>
    <LegalSection title="2. Tecnologías que utiliza este sitio">
      <ul className="list-disc pl-5 space-y-3">
        <li>
          <strong>croclab-cookie-consent</strong> — técnica (almacenamiento
          local, propia): guarda tu elección sobre cookies para no volver a
          preguntarte en cada visita. Proveedor: CROC LAB. Duración: hasta que
          modifiques o retires tu consentimiento. Es imprescindible y permanece
          siempre activa.
        </li>
        <li>
          <strong>PostHog</strong> — analítica (tercero): cookies de
          estadísticas de uso anónimas (páginas visitadas, tipo de dispositivo y
          datos similares). Proveedor: PostHog Inc. Finalidad: entender cómo se
          usa la web y mejorarla. Duración: hasta 12 meses.{" "}
          <strong>
            Solo se activa si aceptas las cookies de analítica en el banner de
            consentimiento.
          </strong>
        </li>
      </ul>
      <p>
        No se utiliza ninguna cookie de marketing, publicidad o seguimiento
        publicitario.
      </p>
    </LegalSection>
    <LegalSection title="3. Consentimiento">
      <p>
        Al entrar en el sitio por primera vez se muestra un banner que te
        permite aceptar todas las cookies, rechazar las no esenciales o
        configurarlas por categoría. Ninguna cookie no esencial se instala antes
        de tu consentimiento.
      </p>
    </LegalSection>
    <LegalSection title="4. Cómo modificar o retirar tu consentimiento">
      <p>
        Puedes cambiar tu decisión en cualquier momento desde el enlace{" "}
        <strong>«Configurar cookies»</strong> del pie de página, que volverá a
        mostrar el panel de preferencias. También puedes eliminar las cookies
        desde la configuración de tu navegador.
      </p>
    </LegalSection>
    <LegalSection title="5. Más información">
      <p>
        Para cualquier duda sobre esta política puedes escribirnos a{" "}
        <a
          href="mailto:croclab.valencia@gmail.com"
          className="text-brand-pink font-semibold hover:underline"
        >
          croclab.valencia@gmail.com
        </a>
        .
      </p>
    </LegalSection>
  </LegalLayout>
);

export default Cookies;
